import React, { useState, useEffect } from "react";
import styles from './modesview.module.css';
import Grid from '@material-ui/core/Grid';
import PastSeason from "./pastseason";
import InfoContainer from "./container/InfoContainer";
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Slider from "react-slick";
import {
    generatePageURI,
    pagePaths
} from '../common/utilities';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { createMuiTheme, useTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function IndexSeasonsView(props) {
    const { t } = useTranslation();

    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down('xs'));
    const [pogData, setPogData] = useState(null);

    //console.log(props.details);

    var titleText = t('Ranked Statistics');
    var linkText = t('View All Seasons');

    // react slider (for mobile view)
    var settings = {
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '12px',
        slidesToShow: 1,
        slidesToScroll: 1
        //,dotsClass: 'mobileSlickDots'
    };

    // first things first... we have to loop through the data and only pull out 'tdm' and 'snd'
    var frontData = [];

    useEffect(() => {

        try{
            if(window.seasonRankingData){
                setPogData(window.seasonRankingData);
                //console.log('got global POG data');
                //console.log(window.seasonRankingData);
            }else{
                setPogData([]);
            }
        }catch(e){
            console.log(e);
            console.log('did not get global POG data');
            setPogData([]);
        }
    }, [pogData]);

    let TIER_STAGE8_COUNT = 0;

    //console.log(props)
    //console.log(props.totalData)

    if(props && props.totalData && pogData){

        //console.log('TIER_STAGE8_COUNT: ' + TIER_STAGE8_COUNT);
        TIER_STAGE8_COUNT = props.totalData;
        //console.log('TIER_STAGE8_COUNT: ' + TIER_STAGE8_COUNT);
    }

    if(props && props.userData){

        //console.log(props.userData);

        var frontData = props.userData.filter(function (seasoninfo) {
            return (seasoninfo.MODE_NO_DESC === "SND" || seasoninfo.MODE_NO_DESC === "TDM");
        });

        //console.log(frontData);

        for(var i=0;i<frontData.length;i++){

            let item = frontData[i];
            if(pogData
                && pogData[parseInt(item.PARTKEY_SEASON_NO,10)]
                && pogData[parseInt(item.PARTKEY_SEASON_NO,10)].POGTotal){
                    //console.log('found pogdata for season: ' + parseInt(item.PARTKEY_SEASON_NO,10));
                    item.TIER_STAGE8_COUNT = pogData[parseInt(item.PARTKEY_SEASON_NO,10)].POGTotal;
                    frontData[i].TIER_STAGE8_COUNT = pogData[parseInt(item.PARTKEY_SEASON_NO,10)].POGTotal;
            }else{
                frontData[i].TIER_STAGE8_COUNT = TIER_STAGE8_COUNT;
            }
        }
        //console.log(frontData);
    }



    var data1 = (props && props.userData && frontData && frontData[0]) ? showSeasonData(frontData[0]) : showSeasonData(null);
    var data2 = (props && props.userData && frontData && frontData[1]) ? showSeasonData(frontData[1]) : showSeasonData(null);
    var data3 = (props && props.userData && frontData && frontData[2]) ? showSeasonData(frontData[2]) : showSeasonData(null);
    var data4 = (props && props.userData && frontData && frontData[3]) ? showSeasonData(frontData[3]) : showSeasonData(null);

    if(mobileView){
        return (

                <Grid item xs={12} spacing={2}>

                    <div className={styles.allModesViewtitle}>{titleText}</div>

                    <Slider {...settings}>
                            <div className={styles.sliderBoxWidth}>{data1}</div>
                            <div className={styles.sliderBoxWidth}>{data2}</div>
                            <div className={styles.sliderBoxWidth}>{data3}</div>
                            <div className={styles.sliderBoxWidth}>{data4}</div>
                    </Slider>

                </Grid>
        );
    }else{
        return (
            <div>
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                        <div className={styles.allModesViewtitle}>{titleText}</div>

                        {data1}

                    </Grid>

                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                        <div className={styles.allModesViewtitle}>&nbsp;</div>

                        {data2}

                    </Grid>

                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                        <div className={styles.allModesViewtitle}>&nbsp;</div>

                        {data3}

                    </Grid>

                    <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>

                        <div className={styles.allModesViewLink}><a href={generatePageURI(pagePaths.RANKED_STATS)}>{linkText}</a></div>

                        {data4}

                    </Grid>

                </Grid>
            </div>
        );
    }

}


function showSeasonData(data){

    /*
    the PastSeason component has been made to accept individual variable paramaters (not an object)
    The null data variable is required as input when there is no ranking data (which happens often)
    */

    var nullData = {
        PARTKEY_SEASON_NO: ''
        ,MODE_NO_DESC: ''
        ,RANK_SCORE: null
        ,RANKING: null
        ,WIN: null
        ,LOSE: null
        ,MATCH_COUNT: null
        ,KILL: null
        ,DEATH: null
        ,TIER_GROUP_ID: null
        ,TIER_GROUP_NAME: null
        ,TIER_STAGE_ID: null
        ,TIER_STAGE8_COUNT: null
      };

      var mySeason = null;

      if(data && data.PARTKEY_SEASON_NO){
        // nothing to do
    }else{

        data = nullData;

    }

    mySeason =  <PastSeason
                    seasonNo={data.PARTKEY_SEASON_NO}
                    mode={data.MODE_NO_DISPLAY_NAME}
                    rank_score={data.RANK_SCORE}
                    ranking={data.RANKING}
                    win={data.WIN}
                    lose={data.LOSE}
                    games={data.MATCH_COUNT}
                    kill={data.KILL}
                    death={data.DEATH}
                    tier_id={data.TIER_GROUP_ID}
                    tier_name={data.TIER_GROUP_NAME}
                    tier_stage={data.TIER_STAGE_ID}
                    TIER_STAGE8_COUNT={data.TIER_STAGE8_COUNT}
                />

    return mySeason;
}